import {
  Button,
  Layout,
  PageHeader,
  Select,
  Input,
  Row,
  Col,
  Breadcrumb,
  Form,
  Divider,
  Radio,
  Spin,
  Alert,
  Checkbox,
} from "antd";
import React, { Component } from "react";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import { connect } from "react-redux";
import "./style.css";
import offerService from "../OfferManagement/service";
import { debounce } from "lodash";
import service from "./service";

const DEFAULT_SERVICES = [
  {
    label: "SMS",
    value: "sms",
  },
  {
    label: "VERIFY",
    value: "verify",
  },
];

const DEFAULT_CONTENTS = [
  {
    label: "notification",
  },
  {
    label: "promotion",
  },
  {
    label: "verification",
  },
];
const KycStatusResponse = {
  969: {
    text: "The customer has done a first-payment but hasn't sent KYC yet. Please Check the waiting confirmation list",
    type: "error",
  },
  3: {
    text: "The customer ever send approval but was not approved. Please Check the waiting confirmation list",
    type: "error",
  },
  925: {
    text: "The customer never sends KYC approval and hasn't ever done the first-payment.",
    type: "info",
  },
  4: {
    text: "The customer has kyc and get approval already.",
    type: "info",
  },
  305: {
    text: "The customer ever send approval but was rejected by admin.",
    type: "error",
  },
};

const routes = () => [
  {
    path: "/so/list",
    breadcrumbName: "Sale Order",
  },
  {
    path: "",
    breadcrumbName: "Sale Order Creation",
  },
];

class CreateSale extends Component {
  state = {
    memberList: [],
    searchLoading: false,
    loading: false,
    hasKyc: true, //? assume each member already have kyc
    noti_text: "",
    noti_type: "",
    hasSelectMember: false,
    isConfirmed: false,
  };

  componentWillMount() {
    this.props.fetchMenuAction("payment", "so");
  }

  handleConfirmationChange = (e) => {
    this.setState({ isConfirmed: e.target.checked });
  };
  
  handleOnSearchMember = async (input) => {
    this.setState({
      searchLoading: true,
    });
    // ? check if input is null
    let res = [];
    if (input !== "") {
      res = await offerService.searchMemberList(input);
    }

    this.setState({
      searchLoading: false,
      memberList: res,
    });
  };

  handleOnChangeMember = async (id) => {
    const findMember = this.state.memberList.find((item) => item.id === id);
    if (!findMember) {
      return;
    }

    const { form } = this.props;
    form.setFieldsValue({
      ...findMember,
      fullname: findMember.firstname + " " + findMember.lastname,
      country_code: findMember.country,
    });

    // ? check kyc
    this.setState({
      loading: true,
    });

    var hasKyc = true;
    const checkingKyc = await service._checkMemberKyc(id);
    // ? not have kyc
    if (checkingKyc["code"]) {
      hasKyc = false;
    }

    const findKycRespKey = checkingKyc["code"]
      ? checkingKyc["code"]
      : checkingKyc["case"];

    this.setState({
      loading: false,
      hasKyc: hasKyc,
      noti_text: KycStatusResponse[findKycRespKey]["text"],
      noti_type: KycStatusResponse[findKycRespKey]["type"],
      hasSelectMember: true,
    });
  };

  handleOnReset = () => {
    const { form } = this.props;
    form.resetFields();
  };

  handleOnSubmit = () => {
    const { form } = this.props;
    this.setState({
      loading: true,
    });

    form.validateFields(async (err, values) => {
      if (err) {
        this.setState({
          loading: false,
        });
        return;
      }

      const payload = {
        ...values,
        amount: parseFloat(values.amount),
      };

      const sendKyc = !this.state.hasKyc;
      const res = await service._submitSaleOrder(payload, sendKyc);
      offerService.handlerError(res);

      form.resetFields();

      this.setState({
        loading: false,
      });
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { isConfirmed } = this.state;

    const formStyle = {
      opacity: isConfirmed ? 1 : 0.5,
      pointerEvents: isConfirmed ? 'auto' : 'none',
      transition: 'opacity 0.3s ease',
    };

    return (
      <Layout>
        <Spin spinning={this.state.loading}>
          <Breadcrumb className="breadcrumb">
            {routes().map((route, idx) => (
              <Breadcrumb.Item key={idx}>
                {route.path ? (
                  <a href={route.path}>{route.breadcrumbName}</a>
                ) : (
                  route.breadcrumbName
                )}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
          <PageHeader
            style={{
              backgroundColor: "#f0f2f5",
            }}
            title={<h2 style={{ fontWeight: "bold" }}>Sale Order Creation</h2>}
          />
          <div className="my-layout">
            <div className="container">

              <div style={{ marginBottom: '24px' }}>
                <Alert
                  message="โปรดยืนยันก่อนสร้าง Sale Order"
                  description={
                    <Checkbox onChange={this.handleConfirmationChange}>
                      ขอยืนยันว่าลูกค้าได้ทำการชำระเงินสำหรับรายการ Sale Order นี้เรียบร้อยแล้ว
                    </Checkbox>
                  }
                  type="info"
                  showIcon
                />
              </div>

              {/* เพิ่ม: div ครอบฟอร์มทั้งหมดเพื่อสั่ง disable */}
              <div style={formStyle}>
                <Form>
                  <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item label="Member" labelCol={{ span: 24 }}>
                        {getFieldDecorator("member_id", {
                          rules: [
                            { required: true, message: "Please select member" },
                          ],
                        })(
                          <Select
                            allowClear
                            showSearch
                            placeholder="Member"
                            optionFilterProp="children"
                          //? delay input by using debouce for 0.6 second
                            onSearch={debounce(this.handleOnSearchMember, 600)}
                            loading={this.state.searchLoading}
                            onChange={(e) => this.handleOnChangeMember(e)}
                          >
                            {this.state.memberList.map((item, i) => (
                              <Select.Option key={i} value={item.id}>
                                {item.id} | {item.email}
                              </Select.Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Email" labelCol={{ span: 24 }}>
                        {getFieldDecorator("email", {
                          rules: [
                            { required: true, message: "Please select member" },
                          ],
                        })(<Input placeholder="Enter Email" />)}
                      </Form.Item>
                    </Col>
                  </Row>
                  {this.state.hasSelectMember && (
                    <Alert
                      type={this.state.noti_type}
                      message={this.state.noti_text}
                      showIcon
                    />
                  )}

                  <Divider orientation="left">Billing Infomation</Divider>

                  <Row gutter={24}>
                    <Col span={6}>
                      <Form.Item label="Amount" labelCol={{ span: 24 }}>
                        {getFieldDecorator("amount", {
                          rules: [
                            {
                              pattern: new RegExp("^[0-9]+([.][0-9]{1,4})?$"),
                              message:
                                "Please enter a number and a maximum of 4 decimals only.",
                            },
                            { required: true, message: "Please Enter Amount" },
                          ],
                        })(<Input placeholder="Enter amount" />)}
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item label="Quotation No." labelCol={{ span: 24 }}>
                        {getFieldDecorator("quotation_no", {
                          rules: [
                            {
                              pattern: new RegExp("^[0-9]+([0-9]{1,9})?$"),
                              message: "Please enter 9 numbers only.",
                            },
                            {
                              required: true,
                              message: "Please enter quotation no.",
                            },
                          ],
                        })(
                          <Input
                            placeholder="Enter quotation no."
                            maxLength={9}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item label="Sale Order No." labelCol={{ span: 24 }}>
                          {getFieldDecorator("order_no", {
                              rules: [
                                  {
                                      pattern: new RegExp("^[0-9]+([0-9]{1,9})?$"),
                                      message: "Please enter 9 numbers only.",
                                  },
                                  {
                                      required: true,
                                      message: "Please enter sale order no.",
                                  },
                              ],
                          })(
                              <Input
                                placeholder="Enter sale order no."
                                maxLength={9}
                              />
                          )}
                      </Form.Item>
                  </Col>
                  <Col span={6}>
                      <Form.Item label="Invoice No." labelCol={{ span: 24 }}>
                          {getFieldDecorator("invoice_no", {
                              rules: [
                                  {
                                      required: true,
                                      message: "Please enter invoice no.",
                                  },
                              ],
                          })(
                              <Input placeholder="Enter invoice no." />
                          )}
                      </Form.Item>
                  </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item label="Name" labelCol={{ span: 24 }}>
                        {getFieldDecorator("fullname", {
                          rules: [
                            { required: true, message: "Please enter full-name" },
                          ],
                        })(<Input placeholder="Enter Full Name" />)}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Company" labelCol={{ span: 24 }}>
                        {getFieldDecorator("company", {
                          rules: [
                            {
                              required: true,
                              message: "Please enter company name",
                            },
                          ],
                        })(<Input placeholder="Enter Company Name" />)}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Address" labelCol={{ span: 24 }}>
                        {getFieldDecorator("address", {
                          rules: [
                            {
                              required: true,
                              message: "Please enter address",
                            },
                          ],
                        })(<Input placeholder="Enter Address" />)}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="City" labelCol={{ span: 24 }}>
                        {getFieldDecorator("city", {
                          rules: [
                            {
                              required: true,
                              message: "Please enter city",
                            },
                          ],
                        })(<Input placeholder="Enter City" />)}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="State" labelCol={{ span: 24 }}>
                        {getFieldDecorator("state", {
                          rules: [
                            {
                              required: true,
                              message: "Please enter state",
                            },
                          ],
                        })(<Input placeholder="Enter state" />)}
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item label="Zip Code" labelCol={{ span: 24 }}>
                        {getFieldDecorator("zip_code", {
                          rules: [
                            {
                              required: true,
                              message: "Please enter Zip Code",
                            },
                          ],
                        })(<Input placeholder="Enter Zip Code" />)}
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item label="Country Code" labelCol={{ span: 24 }}>
                        {getFieldDecorator("country_code", {
                          rules: [
                            {
                              required: true,
                              message: "Please enter Country Code",
                            },
                          ],
                        })(<Input placeholder="Enter Country" />)}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Vat" labelCol={{ span: 24 }}>
                        {getFieldDecorator("is_vat", {
                          rules: [
                            {
                              required: true,
                              message: "Please select whether this order has vat",
                            },
                          ],
                        })(
                          <Radio.Group>
                            <Radio value={1}>Vat</Radio>
                            <Radio value={0}>Not Vat</Radio>
                          </Radio.Group>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  {!this.state.hasKyc && (
                    <div>
                      <Divider orientation="left">KYC Information</Divider>
                      <Row gutter={24}>
                        <Col span={12}>
                          <Form.Item label="Service Type" labelCol={{ span: 24 }}>
                            {getFieldDecorator("service_type", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please enter service type",
                                },
                              ],
                            })(
                              <Select placeholder="Select service type">
                                {DEFAULT_SERVICES.map((service, index) => (
                                  <Select.Option
                                    value={service.value}
                                    key={index}
                                  >
                                    {service.label}
                                  </Select.Option>
                                ))}
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item label="Content Type" labelCol={{ span: 24 }}>
                            {getFieldDecorator("content_type", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please enter content type",
                                },
                              ],
                            })(
                              <Select placeholder="Select content type">
                                {DEFAULT_CONTENTS.map((content, index) => (
                                  <Select.Option
                                    value={content.label}
                                    key={index}
                                  >
                                    {content.label}
                                  </Select.Option>
                                ))}
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item label="Destination" labelCol={{ span: 24 }}>
                            {getFieldDecorator("destination", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please enter content type",
                                },
                              ],
                            })(<Input placeholder="Country destination" />)}
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item label="Social Media" labelCol={{ span: 24 }}>
                            {getFieldDecorator("social_media", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please enter content type",
                                },
                              ],
                            })(<Input placeholder="Product's Social Media" />)}
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            label="Message Example"
                            labelCol={{ span: 24 }}
                          >
                            {getFieldDecorator("message", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please enter content type",
                                },
                              ],
                            })(<Input.TextArea allowClear />)}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  )}
                  <Row gutter={24}>
                    <Col span={24} className={"btn-group"}>
                      <Form.Item style={{ textAlign: "end" }}>
                        <Button type="ghost" onClick={() => this.handleOnReset()}>
                          Clear
                        </Button>
                        <Button
                          type="primary"
                          onClick={() => this.handleOnSubmit()}
                        >
                          Submit
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </Spin>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headerBarStore: state.headerBar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

const formInstance = Form.create({ name: "sale_order_form" })(CreateSale);

export default connect(mapStateToProps, mapDispatchToProps)(formInstance);



// WEBPACK FOOTER //
// ./src/containers/SaleOrder/CreateSale.js